<template>
    <div>Kategori</div>
</template>

<script>
    export default {
        name: "kategori"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/_/kategori.vue